import { createFileRoute, Outlet } from "@tanstack/react-router";
import medicalImg from "@project/assets/home-medical.webp";

export const Route = createFileRoute("/_user/_care/healthcare")({
  head: () => ({
    meta: [
      { title: "Healthcare Services — Jivandhara" },
      {
        name: "description",
        content:
          "On-campus clinic, doctor consultations, medicine support, free check-up camps and emergency care for our residents and the wider community.",
      },
      { property: "og:title", content: "Healthcare Services — Jivandhara" },
      { property: "og:image", content: medicalImg },
    ],
  }),
  component: Outlet,
});
